import { FunctionComponent, HTMLAttributes } from 'preact';
import { useUnifiedWidget } from '../providers/UnifiedWidgetProvider';
import { useConfig } from '../providers/ConfigProvider';
import { useEffect } from 'preact/hooks';

type ChatContentContainerProps = HTMLAttributes<HTMLDivElement> & {
  open: boolean;
  position: string;
  width: number;
  height: number;
}

const ChatContentContainer = ({
  open,
  position,
  width,
  height,
  children,
  ref,
  ...props
}: ChatContentContainerProps) => {
  const { gooberCss } = useUnifiedWidget();

  return (
    <div
      {...props}
      className={gooberCss({
        position: "absolute",
        bottom: 0,
        width: `${width}px`,
        height: `${height}px`,
        right: position === "bottom-right" ? '0' : undefined,
        left: position === "bottom-left" ? '0' : undefined,
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 6px 24px rgba(0, 0, 0, 0.16)",
        visibility: open ? "visible" : "hidden",
        opacity: open ? 1 : 0,
        transform: open ? "translateY(0) scale(1)" : "translateY(30px) scale(0.7)",
        transition: open
          ? "opacity 0.15s ease-out, transform 0.2s cubic-bezier(0.20, 1.35, 0.22, 1)"
          : "opacity 0.1s ease-in, transform 0.1s ease-in",
        maxWidth: open ? "calc(100vw - 30px)" : "0px",
        maxHeight: open ? `${height}px` : "0px",
        pointerEvents: open ? "auto" : "none",
        background: '#ffffff',
      })}
    >
      {children}
    </div>
  )
};

export const ChatContent: FunctionComponent = () => {
  const { open, mode, widgetIframe, gooberCss } = useUnifiedWidget();
  const { config } = useConfig();
  const { position, agentId, width, height } = config;

  const isChatMode = mode === 'chat';
  const showChat = open && isChatMode;

  useEffect(() => {
    if (widgetIframe && showChat) {
      widgetIframe.current?.contentWindow?.focus();
    }
  }, [showChat, widgetIframe]);

  // Always render the iframe when in chat mode - let the iframe handle its own loading state
  // The cookie initialization happens via postMessage from the iframe
  return (
    <ChatContentContainer open={showChat} position={position} width={width} height={height}>
      <iframe 
        ref={widgetIframe}
        src={`${process.env.WEBSITE_DOMAIN}/chat/${agentId}/`}
        tabIndex={0}
        className={gooberCss({
          width: "100%",
          height: "100%",
          border: "none",
        })}
      ></iframe>
    </ChatContentContainer>
  )
}

